export default __webpack_public_path__ + "static/media/nft-4.64a362c6.png";